import type { CategoryConfig } from '@if/mui'
import ArticleIcon from '@mui/icons-material/Article'
import CalculateIcon from '@mui/icons-material/Calculate'
import GavelIcon from '@mui/icons-material/Gavel'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import PaidIcon from '@mui/icons-material/Paid'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'

export const TEMPLATE_CATEGORIES: Record<string, CategoryConfig> = {
  decision: { Icon: GavelIcon },
  documents: { Icon: ArticleIcon },
  income: { Icon: PaidIcon },
  worksheet: { Icon: CalculateIcon },
  urgent: { Icon: PriorityHighIcon, color: 'error' },
  other: { Icon: MoreHorizIcon },
}
